// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    ClassroomEducator,
    ClassroomEducatorFromJSON,
    ClassroomEducatorToJSON,
    ClassroomObjectPermissions,
    ClassroomObjectPermissionsFromJSON,
    ClassroomObjectPermissionsToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClassroomList
 */
export interface ClassroomList {
    /**
     * 
     * @type {string}
     * @memberof ClassroomList
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof ClassroomList
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ClassroomList
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ClassroomList
     */
    subject: string;
    /**
     * 
     * @type {number}
     * @memberof ClassroomList
     */
    maxStudents: number;
    /**
     * 
     * @type {string}
     * @memberof ClassroomList
     */
    readonly imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ClassroomList
     */
    readonly joinCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClassroomList
     */
    archived: boolean;
    /**
     * 
     * @type {ClassroomObjectPermissions}
     * @memberof ClassroomList
     */
    permissions?: ClassroomObjectPermissions;
    /**
     * 
     * @type {Array<ClassroomEducator>}
     * @memberof ClassroomList
     */
    educators?: Array<ClassroomEducator>;
    /**
     * 
     * @type {number}
     * @memberof ClassroomList
     */
    readonly membershipsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ClassroomList
     */
    readonly itemsCount?: number;
}

export function ClassroomListFromJSON(json: any): ClassroomList {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'description': json['description'],
        'subject': json['subject'],
        'maxStudents': json['max_students'],
        'imageUrl': !exists(json, 'image_url') ? undefined : json['image_url'],
        'joinCode': !exists(json, 'join_code') ? undefined : json['join_code'],
        'archived': json['archived'],
        'permissions': !exists(json, 'permissions') ? undefined : ClassroomObjectPermissionsFromJSON(json['permissions']),
        'educators': !exists(json, 'educators') ? undefined : (json['educators'] as Array<any>).map(ClassroomEducatorFromJSON),
        'membershipsCount': !exists(json, 'memberships_count') ? undefined : json['memberships_count'],
        'itemsCount': !exists(json, 'items_count') ? undefined : json['items_count'],
    };
}

export function ClassroomListToJSON(value?: ClassroomList): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'name': value.name,
        'description': value.description,
        'subject': value.subject,
        'max_students': value.maxStudents,
        'archived': value.archived,
        'permissions': ClassroomObjectPermissionsToJSON(value.permissions),
        'educators': value.educators === undefined ? undefined : (value.educators as Array<any>).map(ClassroomEducatorToJSON),
    };
}


